import React from 'react';
import Input from './input/input';
import Select from './select/select';
import Date from './date/date';
import Message from './message/message';

const Field = ({ typename, ...props }) => {
  switch (typename) {
    case 'StrapiFormsFormsFormsInput':
      return <Input key={props.id} {...props} />;
    case 'StrapiFormsFormsFormsSelect':
      return <Select key={props.id} {...props} />;
    case 'StrapiFormsFormsFormsDate':
      return <Date key={props.id} {...props} />;
    case 'StrapiFormsFormsFormsMessage':
      return <Message key={props.id} {...props} />;
    default:
      console.warn(`Didn't understand the form field typename ${typename}`);
      return null;
  }
};

export default Field;
